import Api from "./Api";
import ClientApi from "./ClientApi";

export default {
    checkEntitySubdomain(subdomain , server) {
        return ClientApi(server).get(`check_subdomain_for_passport?subdomain=${subdomain}`);
    },
    createEntity(params) {
        let server = params.server;
        delete params.server;
        return ClientApi(server).post(`create_entity_for_passport` , params);
    },
    attachUserToEntity(entityId){
        const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
        return Api().post(`/add-entity-user` , {
            'entity_id' : entityId,
            'user_id': userId
        });
    }

};
